var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{name:_vm.route}}},[_c('button',{staticClass:"btn parameters-return text-uppercase"},[_c('b-icon-chevron-left'),_vm._v(" retour ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }